import { format, parse } from "date-fns";
import { FormattedMessage as FM } from "react-intl";

import { TrashIcon } from "components/Icons";
import { UserIcon } from "components/Icons";
import { cn } from "tools/ui";

const formatter = Intl.NumberFormat("en-US");
const FORMAT = "dd.MMM.yyy";

const base =
  "m-2 inline-block h-46 cursor-pointer active:scale-95 active:shadow-xl rounded-2xl border border-neutral-300 shadow-md shadow-gray-200 overflow-hidden sm:w-64 md:w-60 lg:w-72 xl:w-80";
const divHead =
  "w-full flex px-4 text-neutral-100 bg-neutral-600 justify-between";
const divContent = "h-full px-4 bg-white text-neutral-600 text-lg";
const styleBtnDelete =
  "cursor-pointer text-2xl text-rose-400 text-right fill-current";
const styleIconUser = "text-2xl text-neutral-400 text-right fill-current";
const clickableStyle = "cursor-pointer active:scale-95 active:shadow-xl";

function CardFolio({ record, onClick, model, layout }) {
  const key = record.id;
  const card_action = [];
  const selectable = card_action.includes("open");
  let clickable = selectable ? clickableStyle : "";
  console.log("Card folio layout...", layout);

  let actionDelete = false;
  if (card_action) {
    for (const action of card_action) {
      if (action === "delete") {
        actionDelete = true;
      }
    }
  }

  function handleDelete(record) {
    onClick(record);
  }

  let state;
  if (state) {
    state = `${model}.${record.registration_state}`;
  }
  let arrival_date = "";
  let departure_date = "";
  if (typeof record.arrival_date === "string") {
    arrival_date = format(
      parse(record.arrival_date, "yyyy-MM-dd", new Date()),
      FORMAT,
    );
    departure_date = format(
      parse(record.departure_date, "yyyy-MM-dd", new Date()),
      FORMAT,
    );
  } else {
    arrival_date = format(record.arrival_date, FORMAT);
    departure_date = format(record.departure_date, FORMAT);
  }

  // onClick={() => handleClick(record)}
  // console.log("record card.... ", record);
  const pax = record.num_adults + record.num_adults;
  return (
    <div key={key} className={cn(base, clickable)}>
      <div className={divHead}>
        <span className="p-3 font-bold text-xl">{record.room.name}</span>
        <TrashIcon onClick={handleDelete} className={styleBtnDelete} />
      </div>
      <div className={divContent}>
        <div className="flex text-lg py-2 font-bold text-sky-600 justify-between">
          <span>{record.product.name}</span>
          <div className="flex p-1 my-auto">
            <UserIcon className={styleIconUser} />
            <span className="pl-2 text-neutral-700">{pax}</span>
          </div>
        </div>
        <div className="flex justify-between text-neutral-600">
          <span>{arrival_date}</span>
          <span className="text-blue-400">|</span>
          <span>{departure_date}</span>
        </div>
        <div className="flex my-2 text-neutral-800 font-bold justify-between">
          <span>{record.nights_quantity} Noches</span>
          <div>
            <span className="text-neutral-400">$ &nbsp; </span>
            <span>{formatter.format(record.unit_price_w_tax || 0)}/noc</span>
          </div>
        </div>
        {state && (
          <div className="flex p-2 w-fit text-green-700 bg-green-200 justify-between rounded-lg">
            <span>
              <FM key={state} id={state} />
            </span>
          </div>
        )}
        <div className="flex text-lg text-neutral-500 justify-between"></div>
      </div>
    </div>
  );
}

export default CardFolio;
